import * as RadixDialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import type { JSX, ReactNode } from "react";

import { IconButton } from "./icon-button";

export interface SheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: ReactNode;
  /** Footer for the actions that belong to the whole panel. */
  footer?: ReactNode | undefined;
}

/**
 * Right-hand drawer: a record's detail, a form that should not hide the list behind it.
 * Rows open a sheet rather than a new page (Attio/Linear pattern).
 */
export function Sheet({ open, onOpenChange, title, children, footer }: SheetProps): JSX.Element {
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-50 bg-overlay" />
        <RadixDialog.Content className="fixed inset-y-0 right-0 z-50 flex w-full max-w-md flex-col border-l border-line bg-surface shadow-overlay">
          <div className="flex items-center justify-between gap-3 border-b border-line px-4 py-3">
            <RadixDialog.Title className="text-h2 font-semibold text-ink">{title}</RadixDialog.Title>
            <RadixDialog.Close asChild>
              <IconButton label="Yopish">
                <X strokeWidth={1.5} aria-hidden="true" />
              </IconButton>
            </RadixDialog.Close>
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4">{children}</div>
          {footer === undefined ? null : (
            <div className="flex items-center justify-end gap-2 border-t border-line px-4 py-3">
              {footer}
            </div>
          )}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}
